import React from "react";

const DashboardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="29"
      viewBox="0 0 33 29"
      fill="none"
    >
      <path
        d="M31 2H2V11H31V2Z"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31 17H21V27H31V17Z"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 17.75H14.75"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="2.25"
        y1="21.75"
        x2="10.75"
        y2="21.75"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 25.75H6.75"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardIcon;
